export default __webpack_public_path__ + "static/media/massup_background_s1.32dbfc65.jpg";